import { z } from 'zod';
import {
  institutionProvisioningSchema,
  institutionSettingsSchema,
} from '@pages/AdminPanel/schemas';

const profileSchema = institutionSettingsSchema.pick({
  name: true,
  language: true,
  address1: true,
  address2: true,
  city: true,
  state: true,
  country: true,
  zip: true,
});

const pocSchema = institutionSettingsSchema.shape.pocSettings.omit({
  city: true,
});

const strictInstitutionSchema = z.object({
  ...profileSchema.shape,
  pocSettings: pocSchema,
  provisioning: institutionProvisioningSchema,
});

export type TCreateInstitutionForm = z.input<typeof strictInstitutionSchema>;

/**
 * Builds the Create Institution form schema.
 * @param isInstitutionProvisioning - Whether the current organization provisions at the institution level.
 * @returns Zod schema for the Create Institution form, including provisioning fields when applicable.
 */
export const createInstitutionSchema = (isInstitutionProvisioning: boolean) =>
  z.object({
    ...profileSchema.shape,
    pocSettings: pocSchema,
    provisioning: isInstitutionProvisioning
      ? institutionProvisioningSchema
      : z.unknown().optional(),
  });
